import ConfigurationLogs from "./ConfigurationLogs";

export default ConfigurationLogs;
